import React, { useState, useEffect } from 'react';
import api from '../api';
import BlogCard from './BlogCard';

export default function BlogList({ openEditModal }) {
  const [blogs, setBlogs] = useState([]);

  const fetchBlogs = async () => {
    try {
      const res = await api.get('/blogs');
      setBlogs(res.data);
    } catch (err) {
      console.error('Error fetching blogs:', err);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
      {blogs.map(blog => (
        <BlogCard
          key={blog.id}
          blog={blog}
          onDeleted={fetchBlogs}
          openEditModal={openEditModal}
        />
      ))}
    </div>
    </div>
  );
}